// Email address matcher.
const matcher = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Loosely validate an email address.
 *
 * @param {string} string
 * @return {boolean}
 */
export function isEmail(string) {
    if (string.length > 320) return false;
    return matcher.test(string);
}

export function getUtmParams(searchParams) {
    return {
        utm_source: searchParams.get("utm_source"),
        utm_medium: searchParams.get("utm_medium"),
        utm_campaign: searchParams.get("utm_campaign"),
        utm_content: searchParams.get("utm_content")
    };
}

export function isCrmActive() {
    return process.env.NEXT_PUBLIC_PROFILE && process.env.NEXT_PUBLIC_PROFILE !== "local";
}

export function isPostHogActive() {
    return process.env.NEXT_PUBLIC_PROFILE
}

export function isDealsEnabled() {
    return true
}

export function formatPrice(value, currency = 'USD', locale = 'en-US') {
    if (isNaN(value)) {
        console.warn('Invalid value provided for formatting.');
        return 'Invalid Price';
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}

export const truncateString = function (str, noOfChar) {
    if (str.length > noOfChar) {
        return str.slice(0, noOfChar) + "...";
    }
    return str;
}
